var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",attrs:{"data-balloon":_vm.displayName,"data-balloon-pos":"right","data-test":`producer-avatar-${_vm.displayName}`}},[_c('img',{attrs:{"src":_vm.profileImageUrl,"alt":`Profile image of ${_vm.displayName}`},on:{"error":function($event){$event.target.src=_vm.defaultAvatar}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }